// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Contract_wrapper__3QV6w","link":"Contract_link__3R4gh"};